import { useEffect, useState } from 'react';
import { Button } from '../../../core-components/Button';
import { PasswordField } from '../../../core-components/PasswordField';
import { replaceTextInNode } from '../../../utils/react-tree';
import { Dialog, DialogContent } from '../../shared/Dialog';
import type { I18NInterface } from '../../../utils';
import type { DialogProps } from '../../shared/Dialog';
import type { FC, ReactNode } from 'react';
export type ManifestPinDialogProps = {
  open?: DialogProps['open'];
  onOpenChange?: DialogProps['onOpenChange'];
  headline?: ReactNode;
  subline?: ReactNode;
  travellerName?: string;
  onPinEnter?: (pin: string) => boolean;
  onPinForgot?: () => void;
  closeable?: boolean;
  i18n?: I18NInterface<'pinDialogContinue' | 'pinDialogPinForgotten' | 'pinDialogHeadline' | 'pinDialogError'>;
};
export const ManifestPinDialog: FC<ManifestPinDialogProps> = ({
  open,
  onOpenChange,
  headline,
  subline,
  travellerName,
  onPinEnter,
  // onPinForgot,
  closeable,
  i18n
}) => {
  const [enteredPin, setEnteredPin] = useState('');
  const [isError, setIsError] = useState(false);

  // Reset error on type
  useEffect(() => {
    setIsError(false);
  }, [enteredPin]);
  const handlePinSubmit = (event: React.SubmitEvent<HTMLFormElement>) => {
    event.preventDefault();
    const success = onPinEnter?.(enteredPin) ?? false;
    if (!success) setIsError(true);
  };
  return <Dialog open={open} onOpenChange={onOpenChange} trackingName="manifest-pin-dialog" data-sentry-element="Dialog" data-sentry-component="ManifestPinDialog" data-sentry-source-file="ManifestPinDialog.tsx">
      <DialogContent disableSpacing bodyClassName="text-marine-high-emphasis p-6 pb-10 space-y-8 bg-neutral-white" title={i18n?.pinDialogHeadline} showCloseButton={closeable !== false} data-sentry-element="DialogContent" data-sentry-source-file="ManifestPinDialog.tsx">
        <div className="space-y-4">
          <h3 className="headline-lg">
            {replaceTextInNode(headline, '{traveller}', travellerName || '')}
          </h3>
          <div className="text-lg">
            {replaceTextInNode(subline, '{traveller}', travellerName || '')}
          </div>
        </div>

        <form className="space-y-4" onSubmit={handlePinSubmit}>
          <div className="mx-auto w-[250px]">
            <PasswordField value={enteredPin} onChange={event => setEnteredPin(event.currentTarget.value)} error={isError ? i18n?.pinDialogError : undefined} data-sentry-element="PasswordField" data-sentry-source-file="ManifestPinDialog.tsx" />
          </div>

          <div className="flex justify-center gap-6">
            {/* PIN change is not in scope of the first implementation (OM-2521)
             <TextButton type="button" onClick={onPinForgot}>
              {i18n?.pinDialogPinForgotten}
             </TextButton>
             */}
            <Button type="submit" data-sentry-element="Button" data-sentry-source-file="ManifestPinDialog.tsx">{i18n?.pinDialogContinue}</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>;
};